export default __webpack_public_path__ + "static/media/appointment-icon.5d51fda1.svg";